import React, { useEffect, useState } from "react";
// import ProfileCard from "../ProfileCard";
import { progressService } from "../../../../../../../services/progressService.js";
import { apiFetch } from "../../../../../../../services/apiFetch.js";
import ProfileCardWithData from "../ProfileCardWithData.jsx";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:8000";


const CurrentStateProfileCard = ({ formData, editableName = false, headerLabel = "Current State", userId, subsectionId }) => {

  // console.log("CurrentStateProfileCard received formData:", formData);
  // console.log("CurrentStateProfileCard received userId:", userId);
  // console.log("CurrentStateProfileCard received subsectionId:", subsectionId);

    // ✅ ADD state to store loaded data
  const [loadedData, setLoadedData] = useState(formData || {});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const loadData = async () => {
    try {
      // ✅ If formData is passed from parent, use it first
      if (formData && Object.keys(formData).length > 0) {
        console.log("✅ Using provided formData");
        setLoadedData(formData);
        setIsLoading(false);
        return;
      }

      if (!userId) {
        console.warn("⚠️ Missing userId");
        setIsLoading(false);
        return;
      }

      // ✅ 1. Try new Section API first
      try {
        console.log("🔄 Fetching NEW Section API data...");

        const course = "course_career_progression";
        const module = "identity";
        const subsection = "current_identity_reflection";


        const response = await apiFetch(
          `${apiBaseURL}/users/${userId}/data/section?course=${course}&module=${module}&subsection=${subsection}`
        );

        const sectionResult = await response.json();

        console.log("📦 NEW API Result:", sectionResult);

        if (sectionResult?.data && Object.keys(sectionResult.data).length > 0) {
          console.log("✅ Loaded data from NEW Section API");
          setLoadedData(sectionResult.data);
          setIsLoading(false);
          return; // ✅ SUCCESS → STOP HERE
        }
      } catch (err) {
        console.error("❌ Section API failed:", err);
        // continue to fallback
      }

      // ✅ 2. Fallback to progressService (OLD data)
      if (!subsectionId) {
        console.warn("⚠️ Missing subsectionId for fallback API");
        setIsLoading(false);
        return;
      }

      console.log("🔄 Fetching FALLBACK progressService data...");
      const progress = await progressService.getUserProgress(userId, subsectionId);

      console.log("📦 Fallback progress:", progress);

      if (progress?.data) {
        console.log("✅ Loaded fallback progress data");
        setLoadedData(progress.data);
      } else {
        console.log("⚠️ No fallback data found");
      }
    } catch (finalErr) {
      console.error("❌ Final failure while loading:", finalErr);
      setError(finalErr.message || "Failed to load profile data");
    } finally {
      setIsLoading(false);
    }
  };

  loadData();
}, [userId, subsectionId, formData]);


  // ✅ Show loading state
  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center p-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#54B0AF] mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading your profile...</p>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="h-full flex items-center justify-center p-8">
        <div className="text-center">
          <div className="text-red-500 mb-4">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  // Show empty state if no data
  if (!loadedData || Object.keys(loadedData).length === 0) {
    return (
      <div className="h-full flex items-center justify-center p-8">
        <div className="text-center">
          <p className="text-gray-600">No profile data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="max-w-2xl w-full">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#323232] font-gotham mb-4">
          We started here...
        </h1>

        <div className="max-w-[429px] mx-auto animate-scale-in relative flex justify-center">
          {/* <ProfileCard formData={loadedData} editableName={editableName} headerLabel={headerLabel} userId={userId} /> */}
          <ProfileCardWithData userId={userId} />
          <div className="absolute bottom-[50%] right-0 translate-x-[100%] w-[95%] h-[5px] bg-[#E0E0E0]"></div>

        </div>

      </div>
    </div>
  );
};

export default CurrentStateProfileCard;
